__turbopack_context__.v({
  "contentParent": "ProgressTabsSection-module__t_WBJG__contentParent",
  "ctaContainer": "ProgressTabsSection-module__t_WBJG__ctaContainer",
  "imageWrapper": "ProgressTabsSection-module__t_WBJG__imageWrapper",
  "imagesContainer": "ProgressTabsSection-module__t_WBJG__imagesContainer",
  "progressCTA": "ProgressTabsSection-module__t_WBJG__progressCTA",
  "sectionContainer": "ProgressTabsSection-module__t_WBJG__sectionContainer",
  "titleSection": "ProgressTabsSection-module__t_WBJG__titleSection",
});
